import { Col, media } from 'ia-react-core';
import styled from 'styled-components';

export const StyledCol = styled(Col)` 
    order: 2;
      
  ${media.lg`
    order: inherit;
  `}  
`;
